import styled from 'styled-components'
import { FlexRow } from './Flex'

export const Label = styled.label`
  color: ${({ theme }) => theme.palette.label.main};
`

export const FormRow = styled(FlexRow)`
  align-items: ${(props) => (props.alignCenter ? 'center' : 'flex-start')};
  justify-content: ${props => props.justifyStart ? 'flex-start' : props.justifyCenter ? 'center' : 'space-between'};
  margin-top: ${(props) => props.marginTop || 0};
`

export const FormControl = styled.div`
  padding-bottom: ${(props) => (props.compact ? '1rem' : '2rem')};
  margin: ${(props) => (props.margin || 0)};

  > * {
    width: 100%;
  }
`

export const FormColControl = styled.div`
  box-sizing: border-box;
  max-width: ${(props) => props.width || 50}%;
  min-width: ${(props) => props.width || 50}%;
  padding: 0 .5rem;
  padding-bottom: ${(props) => (props.compact ? '1rem' : '2rem')};

  &:first-child {
    padding-left: 0 !important;
    padding-right: .5rem !important;
  }

  &:last-child {
    padding-right: 0;
  }

  > * {
    width: ${(props) => (props.noFullChild ? 'auto' : '100%')};
  }
`

export const FormAutoControl = styled.div`
  flex-grow: ${(props) => props.grow === undefined ? 1 : props.grow};

  padding-bottom: ${(props) => (props.compact ? '1rem' : '2rem')};
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  > * {
    width: ${(props) => (props.noFullChild ? 'auto' : '100%')};
  }
`

export const Indicator = styled.span`
  display: inline-block;
  font-weight: bold;
  margin-left: 0.8rem;
  margin-right: ${(props) => props.marginRight || 0};
`
